var map = {
	"./About": [
		"./src/components/About.jsx",
		"vendors-node_modules_react-markdown_lib_react-markdown_js",
		"src_components_About_jsx"
	],
	"./About.jsx": [
		"./src/components/About.jsx",
		"vendors-node_modules_react-markdown_lib_react-markdown_js",
		"src_components_About_jsx"
	],
	"./Education": [
		"./src/components/Education.jsx",
		"vendors-node_modules_react-chrono_dist_react-chrono_esm_js",
		"src_components_Education_jsx"
	],
	"./Education.jsx": [
		"./src/components/Education.jsx",
		"vendors-node_modules_react-chrono_dist_react-chrono_esm_js",
		"src_components_Education_jsx"
	],
	"./Experience": [
		"./src/components/Experience.jsx",
		"vendors-node_modules_react-markdown_lib_react-markdown_js",
		"vendors-node_modules_vertical-timeline-component-for-react_dist_index_js",
		"src_components_Experience_jsx"
	],
	"./Experience.jsx": [
		"./src/components/Experience.jsx",
		"vendors-node_modules_react-markdown_lib_react-markdown_js",
		"vendors-node_modules_vertical-timeline-component-for-react_dist_index_js",
		"src_components_Experience_jsx"
	],
	"./FallbackSpinner": [
		"./src/components/FallbackSpinner.jsx"
	],
	"./FallbackSpinner.jsx": [
		"./src/components/FallbackSpinner.jsx"
	],
	"./Header": [
		"./src/components/Header.jsx",
		"src_components_Header_jsx"
	],
	"./Header.jsx": [
		"./src/components/Header.jsx",
		"src_components_Header_jsx"
	],
	"./Home": [
		"./src/components/Home.jsx"
	],
	"./Home.jsx": [
		"./src/components/Home.jsx"
	],
	"./NavBar": [
		"./src/components/NavBar.jsx"
	],
	"./NavBar.jsx": [
		"./src/components/NavBar.jsx"
	],
	"./Projects": [
		"./src/components/Projects.jsx",
		"vendors-node_modules_react-markdown_lib_react-markdown_js",
		"vendors-node_modules_react-bootstrap_esm_Badge_js-node_modules_react-bootstrap_esm_Button_js--5279e9",
		"src_components_Projects_jsx"
	],
	"./Projects.jsx": [
		"./src/components/Projects.jsx",
		"vendors-node_modules_react-markdown_lib_react-markdown_js",
		"vendors-node_modules_react-bootstrap_esm_Badge_js-node_modules_react-bootstrap_esm_Button_js--5279e9",
		"src_components_Projects_jsx"
	],
	"./Skills": [
		"./src/components/Skills.jsx",
		"vendors-node_modules_react-markdown_lib_react-markdown_js",
		"src_components_Skills_jsx"
	],
	"./Skills.jsx": [
		"./src/components/Skills.jsx",
		"vendors-node_modules_react-markdown_lib_react-markdown_js",
		"src_components_Skills_jsx"
	],
	"./Social": [
		"./src/components/Social.jsx"
	],
	"./Social.jsx": [
		"./src/components/Social.jsx"
	],
	"./ThemeToggler": [
		"./src/components/ThemeToggler.jsx"
	],
	"./ThemeToggler.jsx": [
		"./src/components/ThemeToggler.jsx"
	],
	"./projects/ProjectCard": [
		"./src/components/projects/ProjectCard.jsx",
		"vendors-node_modules_react-markdown_lib_react-markdown_js",
		"vendors-node_modules_react-bootstrap_esm_Badge_js-node_modules_react-bootstrap_esm_Button_js--5279e9",
		"src_components_projects_ProjectCard_jsx"
	],
	"./projects/ProjectCard.jsx": [
		"./src/components/projects/ProjectCard.jsx",
		"vendors-node_modules_react-markdown_lib_react-markdown_js",
		"vendors-node_modules_react-bootstrap_esm_Badge_js-node_modules_react-bootstrap_esm_Button_js--5279e9",
		"src_components_projects_ProjectCard_jsx"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/components lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;